import Croppie from 'croppie';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('croppie', (object, opts) => new Croppie(object, opts));
});
